import React, { useState } from 'react'
import Modal from '../../Modal'
import { AutoColumn } from '../../Column'
import styled from 'styled-components'
import { RowBetween } from '../../Row'
import { TYPE, CloseIcon } from '../../../theme'
import { ButtonError } from '../../Button'
import { useFightAdventureContract } from '../../../hooks/useContract'
import { SubmittedView, LoadingView } from '../../ModalViews'
import { TransactionResponse } from '@ethersproject/providers'
import { useTransactionAdder } from '../../../state/transactions/hooks'
import { useActiveWeb3React } from '../../../hooks'
import { FightAdventureInfo, FIGHT_ADVENTURE_CONTRACT_ADDRESS } from '../../../state/mhub/adventures/fightAdventure'

const ContentWrapper = styled(AutoColumn)`
  width: 100%;
  padding: 1rem;
`

interface FightAdventureClaimModalProps {
  isOpen: boolean
  onDismiss: () => void
  adventureInfo: FightAdventureInfo
}

export default function FightAdventureClaimModal({ isOpen, onDismiss, adventureInfo }: FightAdventureClaimModalProps) {
  const { account } = useActiveWeb3React()

  // monitor call to help UI loading state
  const addTransaction = useTransactionAdder()
  const [hash, setHash] = useState<string | undefined>()
  const [attempting, setAttempting] = useState(false)

  function wrappedOnDismiss() {
    setHash(undefined)
    setAttempting(false)
    onDismiss()
  }

  const adventureContract = useFightAdventureContract(FIGHT_ADVENTURE_CONTRACT_ADDRESS)

  async function onClaimReward() {
    if (adventureContract ) {
      setAttempting(true)
      await adventureContract
        .claimLoot()
        .then((response: TransactionResponse) => {
          addTransaction(response, {
            summary: `Claim accumulated CRO rewards`
          })
          setHash(response.hash)
        })
        .catch((error: any) => {
          setAttempting(false)
          console.log(error)
        })
    }
  }

  let error: string | undefined
  if (!account) {
    error = 'Connect Wallet'
  }

  return (
    <Modal isOpen={isOpen} onDismiss={wrappedOnDismiss} maxHeight={90}>
      {!attempting && !hash && (
        <ContentWrapper gap="lg">
          <RowBetween>
            <TYPE.mediumHeader>Claim</TYPE.mediumHeader>
            <CloseIcon onClick={wrappedOnDismiss} />
          </RowBetween>
          {adventureInfo?.lootBalanceOf && (
            <AutoColumn justify="center" gap="md">
              <TYPE.body fontWeight={600} fontSize={36}>
                {adventureInfo?.lootBalanceOf?.toSignificant(6)}
              </TYPE.body>
              <TYPE.body>CRO Worth of Loot</TYPE.body>
            </AutoColumn>
          )}
          <ButtonError disabled={!!error} error={!!error && !!adventureInfo?.lootBalanceOf} onClick={onClaimReward}>
            {error ?? 'Claim'}
          </ButtonError>
        </ContentWrapper>
      )}
      {attempting && !hash && (
        <LoadingView onDismiss={wrappedOnDismiss}>
          <AutoColumn gap="12px" justify={'center'}>
            <TYPE.body fontSize={20}>
              Claiming {adventureInfo?.lootBalanceOf?.toSignificant(6)} CRO
            </TYPE.body>
          </AutoColumn>
        </LoadingView>
      )}
      {hash && (
        <SubmittedView onDismiss={wrappedOnDismiss} hash={hash}>
          <AutoColumn gap="12px" justify={'center'}>
            <TYPE.largeHeader>Transaction Submitted</TYPE.largeHeader>
            <TYPE.body fontSize={20}>Claimed MHUB!</TYPE.body>
          </AutoColumn>
        </SubmittedView>
      )}
    </Modal>
  )
}
